
import { useTranslationStore } from "@/stores/translation";

export function translate(selector:string){
    const store = useTranslationStore();
    return store.translateValue(selector);
}